import * as _ from "lodash";
import { WB_SpendFunctionRow } from "../PA.Core/PAdbSchemaRows";
import { PAdbContext } from "../PA.Core/PAdbContext";
import { ModelUtils } from "../PA.Model.Services/ModelUtils";
import { ESRecordResolver } from "../PA.Core/lib/ESRecordResolver";
import { esWB_Spend_Function, esWB_Spend_Function_Term_Relationship } from "../PA.Core/PAdbSchema";
import { Domain_getItems } from "../PA.Core/PAdbUtils";

export class SpendFunctionUtils {
    static bCacheLoaded: boolean = false;
    static allSpendFunctions: WB_SpendFunctionRow[] = [];
    static allKnownMetaTypes: string[] = [];
    static async getModelSpendFunctions(
        wbModelId: number,
        sFunctionType: string,
        arrSimulationInputTypes: string[],
        options: { bSkipCache?: boolean; dbContext?: PAdbContext },
    ): Promise<WB_SpendFunctionRow[]> {
        const bSkipCache = !!options.bSkipCache;
        let dbContext = options.dbContext;
        if (_.isEmpty(dbContext)) dbContext = new PAdbContext();

        const predRows = await ModelUtils.getModelPredictorList(wbModelId, { bSkipCache, dbContext });
        const dctPredictorByMetaId = _.keyBy(predRows, (a) => a.cif.PREDICTOR_META_ID);

        if (bSkipCache || !SpendFunctionUtils.bCacheLoaded) {
            // Read in Spend Functions and Terms
            const rr = new ESRecordResolver(dbContext, {
                standardConditions: {
                    [esWB_Spend_Function]: {
                        DELETED_IND: { notIn: ["1"] },
                        [esWB_Spend_Function_Term_Relationship]: { DELETED_IND: { notIn: ["1"] } },
                    },
                },
            });
            const spndFuncs = <WB_SpendFunctionRow[]>await rr.queryAllWithRelationships(esWB_Spend_Function, {
                DELETED_IND: { notIn: ["1"] },
            });

            SpendFunctionUtils.bCacheLoaded = true;
            SpendFunctionUtils.allSpendFunctions = spndFuncs;

            if (_.isEmpty(SpendFunctionUtils.allKnownMetaTypes)) {
                let volItems = await Domain_getItems(dbContext, ["Simulation_Volume_Term"]);
                SpendFunctionUtils.allKnownMetaTypes = _.map(volItems, (a) => a.cif.DOMAIN_ITEM_ID);
            }
        }

        //-- Determine if Spend Functions intersect completely with Model Predictors
        const rv: WB_SpendFunctionRow[] = [];
        const dctVolumeMetas = _.keyBy(SpendFunctionUtils.allKnownMetaTypes, (a) => a);
        const dctSimTypes = _.keyBy(arrSimulationInputTypes, (a) => a);

        _.forEach(SpendFunctionUtils.allSpendFunctions, (row: WB_SpendFunctionRow) => {
            if (!_.isEmpty(sFunctionType)) if (row.cif.FUNCTION_TYPE != sFunctionType) return;

            let bIntersectsAll = true;
            // Check if Terms match
            _.forEach(row.WB_SpendFunctionTermRelationshipRows, (termRow) => {
                const termMetaId = termRow.cif.TERM_META_ID;
                if (
                    !(termMetaId in dctPredictorByMetaId || termMetaId in dctVolumeMetas || termMetaId in dctSimTypes)
                ) {
                    bIntersectsAll = false;
                    return false;
                }
            });

            if (bIntersectsAll) rv.push(row);
        });

        return rv;
    }
}
